module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 586148143651,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.0790583859588306,
		"cl_weight": 0.20067362177661419,
		"fossil_bank_score": 14.0978,
		"fossil_insure_score": 21.1477,
		"wff_mil_weight": 0.0295568661757646,
		"mmc_weight": 0.0295568661757646,
		"cm_weight": 0.007213991085943814,
		"nw_weight": 0.022095549338879715,
		"wff_civ_weight": 0.00914368211704765,
		"gm_weight": 0.0012874636923124493,
		"gr_weight": 0.0078562184247352,
		"t_all_weight": 0.015830789415142744,
		"to_weight": 0.005523807964657357,
		"tm_weight": 0.010306981450485387,
		"po_producer_weight": 0.0015880556454088823,
		"po_financier_weight": 0.02518718406247961,
		"po_consumer_weight": 0.11679530599166135,
		"pp_weight": 0.15319334864294623,
		"borders_weight": 0.18711648889345928,
		"pp_high_weight": 0.0032243806576451334,
		"borders_high_weight": 0.016020263894814205,
		"pff_all_weight": 0.23123188458194316,
		"pff_all_high_weight": 0.016020263894814205,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.7922220465328,
		"gef_score_a": 26.442853586063094,
		"gef_score_b": 9.264550878745315,
		"gef_score_c": 18.447557499590946,
		"gef_score_d": 0.6372600821279061,
		"gef_score_a_norm": 66.10713396515774,
		"gef_score_b_norm": 30.88183626248438,
		"gef_score_c_norm": 92.23778749795473,
		"gef_score_d_norm": 6.37260082127906,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": -2.38712,
		"trailing_return_m3": 2.40069,
		"trailing_return_m6": 8.41954,
		"trailing_return_y1": 24.97722,
		"trailing_return_y3": 8.91004,
		"trailing_return_y5": 14.49381,
		"trailing_return_y10": 13.06324,
		"trailing_return_y15": 13.82691,
		"trailing_return_y20": 10.30584,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 15644051493,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 3,
		"grade_gender_equality": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07769965171057289,
		"cl_weight": 0.17373223967717855,
		"fossil_bank_score": 12.2963,
		"fossil_insure_score": 18.8375,
		"wff_mil_weight": 0.030283541837249982,
		"mmc_weight": 0.030283541837249982,
		"cm_weight": 0.006546003786045646,
		"nw_weight": 0.021223577172577245,
		"wff_civ_weight": 0.008471208143245026,
		"gm_weight": 0.0012540519659356517,
		"gr_weight": 0.007217156177309374,
		"t_all_weight": 0.014018858417655539,
		"to_weight": 0.004907880588587697,
		"tm_weight": 0.009110977829067843,
		"po_producer_weight": 0.0013929245732408394,
		"po_financier_weight": 0.02195612634880481,
		"po_consumer_weight": 0.10442887625761604,
		"pp_weight": 0.13619014429223036,
		"borders_weight": 0.16741173144142957,
		"pp_high_weight": 0.003158869927040759,
		"borders_high_weight": 0.01522391637549414,
		"pff_all_weight": 0.2065720358807086,
		"pff_all_high_weight": 0.015233568221297126,
		"pff_all_extreme_weight": 0.00010469857233333309,
		"gef_score_norm": 53.46681296080196,
		"gef_score_a": 25.990868581894095,
		"gef_score_b": 8.737181450014482,
		"gef_score_c": 18.157509578523538,
		"gef_score_d": 0.5812533503643957,
		"gef_score_a_norm": 64.97717145473524,
		"gef_score_b_norm": 29.12393816671494,
		"gef_score_c_norm": 90.7875478926177,
		"gef_score_d_norm": 5.812533503643957,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": -3.07543,
		"trailing_return_m3": 2.57824,
		"trailing_return_m6": 8.91815,
		"trailing_return_y1": 23.57546,
		"trailing_return_y3": 7.83616,
		"trailing_return_y5": 13.67361,
		"trailing_return_y10": 12.3634,
		"trailing_return_y15": 13.37545,
		"trailing_return_y20": 10.05469,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 71917577820,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.07375071858807189,
		"cl_weight": 0.005481014248279222,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.02828959861529326,
		"mmc_weight": 0.02828959861529326,
		"cm_weight": 0.0033329798654103244,
		"nw_weight": 0.0076003968503457415,
		"wff_civ_weight": 0.0021144049341366364,
		"gm_weight": 0.0006335399999051044,
		"gr_weight": 0.0014808649342315317,
		"t_all_weight": 0.0019383647853849538,
		"to_weight": 0.0008787134876775904,
		"tm_weight": 0.0010596512977073637,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.00327480625580025,
		"pp_weight": 0.006608087946791118,
		"borders_weight": 0.007726377154094074,
		"pp_high_weight": 0.0032643767894539547,
		"borders_high_weight": 0.00451821760721731,
		"pff_all_weight": 0.011272794813489737,
		"pff_all_high_weight": 0.0047209241092758085,
		"pff_all_extreme_weight": 0.0022174112735950883,
		"gef_score_norm": 38.98808704614067,
		"gef_score_a": 20.34379642694367,
		"gef_score_b": 3.3840713312551314,
		"gef_score_c": 15.225878763437201,
		"gef_score_d": 0.0343405245044492,
		"gef_score_a_norm": 50.85949106735917,
		"gef_score_b_norm": 11.280237770850437,
		"gef_score_c_norm": 76.12939381718601,
		"gef_score_d_norm": 0.343405245044492,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": -8.28134,
		"trailing_return_m3": 0.29193,
		"trailing_return_m6": 9.51941,
		"trailing_return_y1": 11.35389,
		"trailing_return_y3": 1.12908,
		"trailing_return_y5": 7.28497,
		"trailing_return_y10": 7.76013,
		"trailing_return_y15": 10.29595,
		"trailing_return_y20": 7.76501,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 40142822298,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07791485173369211,
		"cl_weight": 0.1820310518291686,
		"fossil_bank_score": 12.8989,
		"fossil_insure_score": 19.7567,
		"wff_mil_weight": 0.030342189102720483,
		"mmc_weight": 0.030342189102720483,
		"cm_weight": 0.006696571282116754,
		"nw_weight": 0.021864689492042476,
		"wff_civ_weight": 0.00876384092242075,
		"gm_weight": 0.0012707603964901488,
		"gr_weight": 0.0074930805259305995,
		"t_all_weight": 0.01461547097193846,
		"to_weight": 0.005100673194520326,
		"tm_weight": 0.009514797777418135,
		"po_producer_weight": 0.0014597357761020557,
		"po_financier_weight": 0.023033095001377922,
		"po_consumer_weight": 0.10943092659346873,
		"pp_weight": 0.14253634017800423,
		"borders_weight": 0.17522195287190767,
		"pp_high_weight": 0.0031389191358936197,
		"borders_high_weight": 0.015731917383592444,
		"pff_all_weight": 0.21612929195086378,
		"pff_all_high_weight": 0.015731917383592444,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.85620576593667,
		"gef_score_a": 26.142961924956808,
		"gef_score_b": 8.88100438848099,
		"gef_score_c": 18.23627114488739,
		"gef_score_d": 0.5959683076059006,
		"gef_score_a_norm": 65.35740481239202,
		"gef_score_b_norm": 29.603347961603298,
		"gef_score_c_norm": 91.18135572443695,
		"gef_score_d_norm": 5.959683076059006,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": -2.80037,
		"trailing_return_m3": 2.70729,
		"trailing_return_m6": 8.91369,
		"trailing_return_y1": 24.32617,
		"trailing_return_y3": 8.26841,
		"trailing_return_y5": 14.12379,
		"trailing_return_y10": 12.72688,
		"trailing_return_y15": 13.63807,
		"trailing_return_y20": 10.25872,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 53259784045,
		"grade_fossil": 5,
		"grade_deforestation": 5,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.10931998385649706,
		"cl_weight": 0.12402069485934514,
		"fossil_bank_score": 28.2658,
		"fossil_insure_score": 22.3429,
		"wff_mil_weight": 0.03420771397902123,
		"mmc_weight": 0.03420771397902123,
		"cm_weight": 0.0050411202997403155,
		"nw_weight": 0.0207722134347386,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.016183945663017247,
		"to_weight": 0.00792464955490925,
		"tm_weight": 0.008259296108107998,
		"po_producer_weight": 0.015087311214847242,
		"po_financier_weight": 0.07940566759292879,
		"po_consumer_weight": 0.11115855234253604,
		"pp_weight": 0.015030231163166733,
		"borders_weight": 0.0298058672227655,
		"pp_high_weight": 0.0010990247578106002,
		"borders_high_weight": 0.0063023847203790674,
		"pff_all_weight": 0.03230844145971893,
		"pff_all_high_weight": 0.007401409478189668,
		"pff_all_extreme_weight": 0.0004437386763188208,
		"gef_score_norm": 57.15252331147034,
		"gef_score_a": 25.12175970332571,
		"gef_score_b": 13.271821583173706,
		"gef_score_c": 17.446425812099424,
		"gef_score_d": 1.3125162128662873,
		"gef_score_a_norm": 62.804399258314284,
		"gef_score_b_norm": 44.23940527724569,
		"gef_score_c_norm": 87.23212906049712,
		"gef_score_d_norm": 13.125162128662874,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": -2.8695,
		"trailing_return_m3": -8.44506,
		"trailing_return_m6": -1.85088,
		"trailing_return_y1": 3.42874,
		"trailing_return_y3": 1.53944,
		"trailing_return_y5": 4.67522,
		"trailing_return_y10": 5.13934,
		"trailing_return_y15": 5.16126,
		"trailing_return_y20": 4.72959,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 17117661730,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.10028019015334623,
		"cl_weight": 0.13787728914090125,
		"fossil_bank_score": 7.8605,
		"fossil_insure_score": 6.9688,
		"wff_mil_weight": 0.03324281972597246,
		"mmc_weight": 0.03324281972597246,
		"cm_weight": 0.00593154259022048,
		"nw_weight": 0.02423836883535879,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.0036440482989659037,
		"to_weight": 0.0036440482989659037,
		"tm_weight": 0,
		"po_producer_weight": 0.011000226477431983,
		"po_financier_weight": 0.021263963319103883,
		"po_consumer_weight": 0.0105986666014552,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": -1,
		"gef_score_a": 22.41938426344202,
		"gef_score_b": 7.218395557585321,
		"gef_score_c": 16.449014597376394,
		"gef_score_d": 0.33415998720829065,
		"gef_score_a_norm": -1,
		"gef_score_b_norm": -1,
		"gef_score_c_norm": -1,
		"gef_score_d_norm": -1,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": -1.01041,
		"trailing_return_m3": -6.91124,
		"trailing_return_m6": 0.09893,
		"trailing_return_y1": 6.94385,
		"trailing_return_y3": -2.55606,
		"trailing_return_y5": 0.92927,
		"trailing_return_y10": 2.94038,
		"trailing_return_y15": 2.20851,
		"trailing_return_y20": 5.2914,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 4832547087,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.11748872230359944,
		"cl_weight": 0.12319308478053016,
		"fossil_bank_score": 28.3853,
		"fossil_insure_score": 16.1002,
		"wff_mil_weight": 0.03339709708197572,
		"mmc_weight": 0.03339709708197572,
		"cm_weight": 0.004979985993640942,
		"nw_weight": 0.022178327520451752,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.011267914916347788,
		"to_weight": 0.0060731621971232335,
		"tm_weight": 0.005194752719224556,
		"po_producer_weight": 0.012672410381182839,
		"po_financier_weight": 0.05608215047316333,
		"po_consumer_weight": 0.07423686403455583,
		"pp_weight": 0.011214227155800002,
		"borders_weight": 0.01963135448882762,
		"pp_high_weight": 0.0006820990098443697,
		"borders_high_weight": 0.004901824092785248,
		"pff_all_weight": 0.022995495414364242,
		"pff_all_high_weight": 0.005583923102629618,
		"pff_all_extreme_weight": 0.00026958946848111256,
		"gef_score_norm": 56.167687047769476,
		"gef_score_a": 25.081630842961044,
		"gef_score_b": 12.47318741190127,
		"gef_score_c": 17.400340420566497,
		"gef_score_d": 1.2125283723360758,
		"gef_score_a_norm": 62.70407710740261,
		"gef_score_b_norm": 41.57729137300423,
		"gef_score_c_norm": 87.0017021028325,
		"gef_score_d_norm": 12.125283723360758,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": -2.56028,
		"trailing_return_m3": -7.51034,
		"trailing_return_m6": -0.37048,
		"trailing_return_y1": 5.19242,
		"trailing_return_y3": 0.66146,
		"trailing_return_y5": 3.90231,
		"trailing_return_y10": 4.65118,
		"trailing_return_y15": 4.41392,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 19245163166,
		"grade_fossil": 4,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.0880985458381351,
		"cl_weight": 0.17019113341097797,
		"fossil_bank_score": 18.6768,
		"fossil_insure_score": 15.9627,
		"wff_mil_weight": 0.030388329265518262,
		"mmc_weight": 0.030388329265518262,
		"cm_weight": 0.0062667720140344545,
		"nw_weight": 0.021926134819052534,
		"wff_civ_weight": 0.006145659831962587,
		"gm_weight": 0.0008319954581720129,
		"gr_weight": 0.005313664373790574,
		"t_all_weight": 0.013827295818315558,
		"to_weight": 0.005636455441381256,
		"tm_weight": 0.008190840376934305,
		"po_producer_weight": 0.00517290703047059,
		"po_financier_weight": 0.03516458229649276,
		"po_consumer_weight": 0.1000799018040363,
		"pp_weight": 0.09793947300881446,
		"borders_weight": 0.12677425237648834,
		"pp_high_weight": 0.0023449929198784032,
		"borders_high_weight": 0.012225301847237203,
		"pff_all_weight": 0.15332329347096027,
		"pff_all_high_weight": 0.012455944807794956,
		"pff_all_extreme_weight": 0.00009392912653846272,
		"gef_score_norm": 54.87707905302774,
		"gef_score_a": 25.948998058513517,
		"gef_score_b": 10.02830484553231,
		"gef_score_c": 18.132668280876693,
		"gef_score_d": 0.7671078680999392,
		"gef_score_a_norm": 64.8724951462838,
		"gef_score_b_norm": 33.42768281844103,
		"gef_score_c_norm": 90.66334140438347,
		"gef_score_d_norm": 7.6710786809993925,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": -2.57192,
		"trailing_return_m3": -0.9372,
		"trailing_return_m6": 5.50423,
		"trailing_return_y1": 17.41091,
		"trailing_return_y3": 5.45893,
		"trailing_return_y5": 10.07372,
		"trailing_return_y10": 9.34435,
		"trailing_return_y15": 9.27445,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2024-12-31T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 999
// module chunks = 0